import { render } from "./DocumentExecutionWordDetail.vue?vue&type=template&id=7f5ca660&scoped=true&ts=true"
import script from "./DocumentExecutionWordDetail.vue?vue&type=script&lang=ts"
export * from "./DocumentExecutionWordDetail.vue?vue&type=script&lang=ts"

import "./DocumentExecutionWordDetail.vue?vue&type=style&index=0&id=7f5ca660&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5ca660"]])

export default __exports__